// TODO: okomentovat https://cncenter.atlassian.net/browse/FEG-503

import { getUrlParamNumberValue } from '@utils/urlParam';

export interface IArticleListedState {
  activeChapter: number;
  chapterInUrl?: number;
  lastChapter?: number | undefined;
}

class ArticleListedState implements IArticleListedState {
  activeChapter: number = 1;

  chapterInUrl: number;

  lastChapter: number | undefined;

  private static instance: ArticleListedState;

  private constructor(activeChapter: number = 1) {
    this.chapterInUrl = getUrlParamNumberValue(window.location.search, 'chapter');
    this.activeChapter = this.chapterInUrl ? +this.chapterInUrl : activeChapter;
  }

  static getInstance() {
    if (this.instance) {
      return this.instance;
    }
    this.instance = new ArticleListedState();
    return this.instance;
  }

  increaseActiveChapter() {
    this.activeChapter += 1;
  }

  decreaseActiveChapter() {
    this.activeChapter = this.activeChapter > 1 ? this.activeChapter - 1 : 1;
  }

  setActiveChapter(index: number): void {
    this.activeChapter = index > 0 ? index : 1;
  }

  setLastChapter(index: number): void {
    this.lastChapter = index;
  }

  getActiveChapter(): number {
    return this.activeChapter;
  }

  getIsFirst(): boolean {
    return this.activeChapter === 1;
  }

  getIsLast(): boolean {
    return this.activeChapter === this.lastChapter;
  }
}

export const articleListedState = ArticleListedState.getInstance();
